import { NUMBER_MASK } from './accounts'

export const MaskedNumber = ({ number }: { number: string }) => (
  <span className="whitespace-nowrap tabular-nums">
    <span className="mr-0.5 font-normal text-ink-subtle">{NUMBER_MASK}</span>
    {number}
  </span>
)
